import React from 'react';
import ConquestIntegrationLayout from './ConquestIntegrationLayout';
import { NAV_PATHS } from '@/utils/constants';
import { useHistory, useParams } from 'react-router';
import EmptyStateCard from '@/views/components/misc/EmptyStateCard';
import { getConquestAppUrl } from '@/utils/planning';
import { connect } from 'react-redux';
import { ReduxState } from '@/redux/modules/types';
import EnterpriseDetailInfo from '@/types/enterprise-detail-info';

const i18nBasePath = 'Planning.Conquest.ErrorPage';
const i18nEmptyStatePath = 'EmptyStateCard.Planning.ErrorPage';
const supportedErrorKeys = ['contactNotFound'];

type Props = {
  enterprise?: EnterpriseDetailInfo;
};

const ErrorPage: React.FC<Props> = ({ enterprise }) => {
  const { errorKey } = useParams<{ errorKey: string }>();
  const resolvedErrorKey = supportedErrorKeys.includes(errorKey) ? errorKey : 'defaultError';
  const history = useHistory();
  const conquestUrl = getConquestAppUrl(enterprise);

  const onClose = () => {
    history.push(NAV_PATHS.CONTACTS);
  };

  const emptyStateDefinition = {
    titlePath: `${i18nEmptyStatePath}.${resolvedErrorKey}.Title`,
    messagePath: `${i18nEmptyStatePath}.${resolvedErrorKey}.Message`,
    links: conquestUrl ? [{ label: `${i18nEmptyStatePath}.${resolvedErrorKey}.LinkText`, isExternalLink: true, to: conquestUrl }] : undefined,
  };

  return (
    <ConquestIntegrationLayout mainClassName="contacts-v2 planning-error-page" onClose={onClose} i18nBasePath={i18nBasePath} hideTitleAndInstructions>
      <div className="error-body">
        <EmptyStateCard {...emptyStateDefinition} />
      </div>
    </ConquestIntegrationLayout>
  );
};

const mapStateToProps = (state: ReduxState) => ({
  enterprise: state.auth.user?.enterprise,
});

export default connect(mapStateToProps)(ErrorPage);
